import React from 'react';
import { Card, CardHeader, CardContent, CardActions, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme, elevation }) => ({
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: elevation === 0 ? 'none' : '0px 1px 2px rgba(0, 0, 0, 0.05)',
    backgroundColor: theme.palette.background.paper,
}));

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: '#fafafa',

    '& .MuiCardHeader-title': {
        fontSize: '0.9375rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },

    '& .MuiCardHeader-subheader': {
        fontSize: '0.75rem',
        marginTop: '2px',
    },
}));

const StyledCardContent = styled(CardContent)({
    padding: '16px',
    '&:last-child': {
        paddingBottom: '16px',
    },
});

const StyledCardActions = styled(CardActions)(({ theme }) => ({
    padding: '12px 16px',
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: '#fafafa',
}));

const LsCard = ({
    title,
    subheader,
    action,
    children,
    actions,
    elevation = 1,
    ...props
}) => {
    return (
        <StyledCard elevation={elevation} {...props}>
            {(title || action) && (
                <StyledCardHeader
                    title={title}
                    subheader={subheader}
                    action={action}
                />
            )}
            <StyledCardContent>
                {children}
            </StyledCardContent>
            {actions && (
                <StyledCardActions>
                    {actions}
                </StyledCardActions>
            )}
        </StyledCard>
    );
};

export default LsCard;